import React from 'react';
import {connect} from 'react-redux';
import {changeItemQuantity} from '../../actions/store/itemCardActions';
import {joinChangeItemQuantity} from "../../actions/join/joinActions";
import {setDirty} from "../../actions/common/commonActions";
import {translate} from '../../i18n/translate';
import {showLoginSignupModal, updateStoreDataAvailability} from "../../actions/store/storeActions";
import ModalPopup from"../../components/common/ModalPopup";
import {isFetching} from "../../actions/common/fetchingActions";
import {FetchingTypes} from "../../common/constants";
import styles from "../../css/QuantityUpdater.less";

class QuantityUpdater extends React.Component {
    state = {
        showPopup: false,
        showSchedulePopup: false,
        showItemVariationPopup: false
    };

    getMinOrderAddAmount = () => {
		return ((this.props.isOrderSummary && this.props.item.minQuantity) || 0);
	};

    onAddButtonClick = () => {
        if(!this.props.isJoinFlow && !this.props.memberDetails.key && !this.props.staticData.allowDraftOrderBeforeLogin) {
            this.props.openLoginSignupPopup();
            return;
        }
        if(this.props.variantSelected) {
            this.setState({showItemVariationPopup:true});
            return;
        }
        const isItemHasSchedules = this.props.item.schedules && this.props.item.schedules.length > 1;
        if(this.props.isJoinFlow && isItemHasSchedules && !this.props.item.selectedSchedule && !this.props.item.waitList){
            this.setState({showSchedulePopup:true});
            return;
        }
        this.props.changeItemQuantity(this.props.item, this.props.item.quantity + 1+this.getMinOrderAddAmount(),
            this.props.isJoinFlow, this.props.creditsData, this.props.staticData, this.props.itemsList, this.props.activeOrder);

    };

    onMinusButtonClick = () => {
        this.props.changeItemQuantity(this.props.item, Math.max(this.props.item.quantity - 1+this.getMinOrderAddAmount(), 0),
            this.props.isJoinFlow, this.props.creditsData, this.props.staticData, this.props.itemsList, this.props.activeOrder);
    };

    onPlusButtonClick = () => {
        //if(!this.props.item.moreAvailable)
        //    return;
        this.props.changeItemQuantity(this.props.item, this.props.item.quantity + 1+this.getMinOrderAddAmount(),
            this.props.isJoinFlow, this.props.creditsData, this.props.staticData, this.props.itemsList, this.props.activeOrder);
    };

    closePopup = () => {
      this.setState({showPopup:false});
    };

    closeSchedulePopup = () => {
      this.setState({showSchedulePopup:false});
    };

    closeItemVariationPopup = () => {
        this.setState({showItemVariationPopup:false});
    };

    getSelectItemVariationPopup = () => {
        if (this.state.showItemVariationPopup) {
            return (<ModalPopup
                onClose={this.closeItemVariationPopup}
                message={translate("_SelectVariationForItem")}
                middle={{text: translate('Close'), callback: this.closeItemVariationPopup}}/>);
        }
    };

    getSchedulePopUp = () => {
        if (!this.state.showSchedulePopup)
            return null;
        return (
            <ModalPopup
                onClose={this.closeSchedulePopup}
                message={translate("_SelectScheduleForShare")}
                middle={{text:translate('Close'), callback:this.closeSchedulePopup}}/>
        );
    };

    getOrderSummaryQuantityUpdater = (quantity, moreAvailable) => {
        if(this.props.clientViewPort.isXs){
            return (
                <div className="qty-update">
                    <div className={this.props.clientViewPort.isXs? "minus-wrapper" : ""}> <button className="button btn-primary qtn-btn minus-button" name="btnMinusOrderSummary" onClick={this.onMinusButtonClick} disabled={!this.props.allowChange}/></div>
                    <div className={this.props.clientViewPort.isXs? "quantity-wrapper" :""}><div className="quantity" name="quantityOrderSummary"><span>{quantity}</span></div></div>
                    <div className={this.props.clientViewPort.isXs? "plus-wrapper":""}><button className="button btn-primary qtn-btn plus-button" name="btnPlusOrderSummary" disabled={!moreAvailable || !this.props.allowChange} onClick={this.onPlusButtonClick}/></div>
                </div>
            );
        }
        return (
            <div className="qty-update">
                <button className="button btn-primary qtn-btn minus-button" name="btnMinusOrderSummary" onClick={this.onMinusButtonClick} disabled={!this.props.allowChange}/>
                <div className="quantity" name="quantityOrderSummary"><span>{quantity}</span></div>
                <button className="button qtn-btn plus-button" name="btnPlusOrderSummary" disabled={!moreAvailable || !this.props.allowChange} onClick={this.onPlusButtonClick}/>
            </div>
        );
    };

    render() {
		const item = this.props.item;
        const quantity = item.quantity;
        const minQuantity = item.minQuantity;
		const fullQuantity = quantity + this.getMinOrderAddAmount();
        const availability = this.props.isJoinFlow ? (item.capacity - item.usageCount) : item.available;
        // const moreAvailable = (fullQuantity < item.maxPerMember) && (item.waitList || (fullQuantity - item.orderedQuantity < availability)); //In case of waitlist should not check availability
		const moreAvailable = this.props.staticData.updateItemAvailabilityOnItemQuantityChange ?
            (fullQuantity <= (item.maxPerMember -1)) && (item.waitList || (fullQuantity < availability)) : //availability already includes the ordered quantity
            (fullQuantity <= (item.maxPerMember -1)) && (item.waitList || (fullQuantity - item.orderedQuantity < availability)); //In case of waitlist should not check availability
        const soldOut = !item.waitList  && availability <= 0;
        const disableUpdates = this.props.isUpdatingItemAvailability;
        if(!quantity || quantity === 0){
            return (
                <div className="qty-update">
                    <button className={"button btn-primary not-available" + (this.props.details ? " details" : "") + (!soldOut ? " add-button" : " sold-out") + (disableUpdates ? " button loading" : "")} name="btnAdd"
                            onClick={this.onAddButtonClick} disabled={!moreAvailable || (this.props.item.schedules && this.props.item.schedules.length < 1)}>{soldOut ? translate("Sold Out") : (!this.props.clientViewPort.isXs || this.props.details) ? translate("Add") : ''}</button>
                    {this.getSelectItemVariationPopup()}
                    {this.getSchedulePopUp()}
                </div>
            )
        }else {
            if(this.props.isOrderSummary || this.props.isReucrring){
                return this.getOrderSummaryQuantityUpdater(quantity, moreAvailable);
            } else {
                const classname = this.props.isJoinFlow || this.props.shouldShowQuantityUpdater || this.props.clientViewPort.isXs ? "qty-update plus-minus" : "qty-update off";
                return (
                    <div className={classname}>
                        <div className = {this.props.clientViewPort.isXs? "" : "row"}>
                            <div className={this.props.clientViewPort.isXs? "minus-wrapper" : "minus-wrapper col-sm-4"}><button className="button btn-primary qtn-btn minus-button" name="btnMinus" onClick={this.onMinusButtonClick} disabled={quantity===minQuantity || disableUpdates}/></div>
                            <div className={this.props.clientViewPort.isXs? "quantity-wrapper" : "quantity-wrapper col-sm-4"}><div className="quantity">{quantity}</div></div>
                            <div className={this.props.clientViewPort.isXs? "plus-wrapper" : "plus-wrapper col-sm-4"}><button className={"button btn-primary qtn-btn plus-button" + (disableUpdates ? " loading" : "")} name="btnPlus" disabled={!moreAvailable || disableUpdates} onClick={this.onPlusButtonClick}/></div>
                        </div>
                    </div>
                )
            }
        }

    }
}

const mapStateToProps = (state) => {
    const status = (state.orderStatus || {});
    const staticData = (state.staticData || {});
    return {
        clientViewPort: (state.clientViewPort || {}),
        creditsData: (state.storeCreditsData || {}),
        memberDetails: (state.memberDetails || {}),
        itemsList: state.itemsList,
        activeOrder: status.activeOrder,
        isUpdatingItemAvailability: isFetching(state, FetchingTypes.UPDATE_ITEM_AVAILABILITY),
        staticData
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        changeItemQuantity: (item, newQuantity, isJoinFlow, creditsData, staticData, itemsList, activeOrder) => {
            if(!ownProps.changeItemQuantity) {
                let oldQuantity = ownProps.item.quantity;
                if (isJoinFlow) {
                    dispatch(joinChangeItemQuantity(item.key, newQuantity));
                    dispatch(setDirty(true));
                } else {
                    dispatch(changeItemQuantity(item, newQuantity, oldQuantity, creditsData));
                }
            } else {
                ownProps.changeItemQuantity(item, newQuantity);
            }

            if (staticData.updateItemsAvailabilityOnCategoryChange) {
                dispatch(updateStoreDataAvailability(staticData, item.category, itemsList, activeOrder, item.key));
            }
            // if (oldQuantity == newQuantity)
            //     return;
            // let source = ownProps.isOrderSummary ? GA.GA_LABELS.CART :
            //     ownProps.details ? GA.GA_LABELS.DETAILS :
            //         GA.GA_LABELS.ITEM;
            // let action = (newQuantity < oldQuantity) ?
            //     ((newQuantity > 0 ) ? GA.GA_ACTIONS.ITEM_QUANTITY_DECREASED : GA.GA_ACTIONS.ITEM_REMOVED) :
            //     ((oldQuantity > 0) ? GA.GA_ACTIONS.ITEM_QUANTITY_INCREASED : GA.GA_ACTIONS.ITEM_ADD_CLICKED);

//            dispatch(GA.trackGAEvent(GA.GA_CATEGORIES.STORE, action, source));
        },
        openLoginSignupPopup: () => {
            dispatch(showLoginSignupModal(true));
        }
    }
};

export default  connect(mapStateToProps, mapDispatchToProps)(QuantityUpdater);


// WEBPACK FOOTER //
// ./src/containers/common/QuantityUpdater.js